<template>
  <div class="content_box">
    <headPage></headPage>
    <div class="banner_box">
      <img class="img_banner" src="../../assets/img/banner.jpg" alt="" />
      <div class="content">
        <div class="big_msg"><span>银保镖</span> - 国内领先的电子保函平台</div>
        <div class="mini_msg">在线办理、电话办理全支持</div>
      </div>
    </div>
    <div class="contact">
      <div class="left_txt">
        <div class="title">联系<span>银保镖</span></div>
        <div class="list">
          <p>办公地址</p>
          <p>北京市海淀区北清路68号用友产业园中区8F座</p>
        </div>
        <div class="list">
          <p>联系电话</p>
          <p>400-895-8805</p>
        </div>
        <div class="list">
          <p>保函办理顾问微信</p>
          <p>baohan16888</p>
        </div>
        <div class="list">
          <p>合作邮箱</p>
          <p>76679004@qq.com</p>
        </div>
        <img src="../../assets/img/dyCode.png" alt="" />
      </div>
      <img src="../../assets/img/contactBanner.jpg" alt="" />
    </div>
    <footPage></footPage>
  </div>
</template>

<script>
import headPage from '@/components/head/index.vue'
import footPage from '@/components/foot/index.vue'
export default {
  components: { headPage, footPage },
  data() {
    return {}
  },
  mounted() {},
  methods: {}
}
</script>

<style scoped lang="scss">
@import './index.scss';
</style>
